<template>
  <div>
    <LoadingText v-if="loading" />
    <!-- <div style="font-size:13px;" v-else>
      <v-row style="margin:0;" >
        <v-col :cols="5" style="padding-top:0.3rem;padding-bottom:0.3rem;padding-right:0.3rem;padding-left:30px;">
          通道名称
        </v-col>
        <v-col :cols="2.3" style="padding:0.3rem 0.2rem;text-align:center;">
          录像状态
        </v-col>
        <v-col :cols="2.3" style="padding:0.3rem 0.2rem;text-align:center;">
          信号状态
        </v-col>
        <v-col :cols="2.4" style="padding:0.3rem 0.2rem;text-align:center;">
          硬件状态
        </v-col>
      </v-row>
      <v-row v-for="(item,index) in abnormalList" :key="'off' + index" style="margin:0;" >
        <v-col :cols="5" style="padding-top:0.3rem;padding-bottom:0.3rem;padding-right:0.3rem;">
          <div style="text-overflow:ellipsis;overflow:hidden;width:100%;position: relative;" :title="item.name">
            <span style="color:#9e9e9e;width:15px;display:inline-block;position: absolute;">{{ index + 1 }}</span>
            <span style="display:inline-block;margin-left:17px;">{{item.name}}</span>
          </div>
        </v-col>
        <v-col :cols="2.3" style="padding:0.8rem 0.2rem 0.3rem 0.2rem;text-align:center;">
            <div v-if="item.record_static == 1" style="color:#67C23A;">录像</div>
            <div v-else style="color:#F56C6C;">不录像</div>
        </v-col>
        <v-col :cols="2.3" style="padding:0.8rem 0.2rem 0.3rem 0.2rem;text-align:center;">
            <div v-if="item.signal_static == 0" style="color:#67C23A;">正常</div>
            <div v-else style="color:#F56C6C;">信号丢失</div>
        </v-col>
        <v-col :cols="2.4" style="padding:0.8rem 0.2rem 0.3rem 0.2rem;text-align:center;">
            <div v-if="item.hardware_static == 0" style="color:#67C23A;">正常</div>
            <div v-else style="color:#F56C6C;">异常</div>
        </v-col>
        <v-col :cols="12" style="padding-top: 0px;padding-bottom: 0px;">
          <div style="color:#9e9e9e;margin-left:17px;">
            <span style="display:inline-block;margin-right:10px;">{{item.ip}}</span>
            <span style="display:inline-block;">通道：{{(item.index + 1)}}</span>
          </div>
        </v-col>
      </v-row>
      <v-divider v-if="abnormalList.length > 0" style="margin: 10px 0;"></v-divider>
      <v-row v-for="(item,index) in normalList" :key="index" style="margin:0;" >
        <v-col :cols="5" style="padding-top:0.3rem;padding-bottom:0.3rem;padding-right:0.3rem;">
          <div style="text-overflow:ellipsis;overflow:hidden;width:100%;position: relative;" :title="item.name">
            <span style="color:#9e9e9e;width:15px;display:inline-block;position: absolute;">{{ index + 1 }}</span>
            <span style="display:inline-block;margin-left:17px;">{{item.name}}</span>
          </div>
        </v-col>
        <v-col :cols="2.3" style="padding:0.8rem 0.2rem 0.3rem 0.2rem;text-align:center;">
            <div v-if="item.record_static == 1" style="color:#67C23A;">录像</div>
            <div v-else style="color:#F56C6C;">不录像</div>
        </v-col>
        <v-col :cols="2.3" style="padding:0.8rem 0.2rem 0.3rem 0.2rem;text-align:center;">
            <div v-if="item.signal_static == 0" style="color:#67C23A;">正常</div>
            <div v-else style="color:#F56C6C;">信号丢失</div>
        </v-col>
        <v-col :cols="2.4" style="padding:0.8rem 0.2rem 0.3rem 0.2rem;text-align:center;">
            <div v-if="item.hardware_static == 0" style="color:#67C23A;">正常</div>
            <div v-else style="color:#F56C6C;">异常</div>
        </v-col>
        <v-col :cols="12" style="padding-top: 0px;padding-bottom: 0px;">
          <div style="color:#9e9e9e;margin-left:17px;">
            <span style="display:inline-block;margin-right:10px;">{{item.ip}}</span>
            <span style="display:inline-block;">通道：{{(item.index + 1)}}</span>
          </div>
        </v-col>
      </v-row>
      <div v-if="abnormalList.length === 0 && normalList.length === 0" style="text-align:center;margin-top:1rem;color:#9e9e9e;font-size:0.8rem;">
          暂无通道设备
      </div>
    </div> -->
    <div style="font-size:13px;" v-else>
      <v-row style="margin:0;" >
        <v-col :cols="6" style="padding-top:0.3rem;padding-bottom:0.3rem;padding-right:0.3rem;padding-left:30px;">
          通道名称
        </v-col>
        <v-col :cols="5" style="padding:0.3rem 0.2rem;text-align:center;">
          状态
        </v-col>
      </v-row>
      <v-row v-for="(item,index) in abnormalList" :key="'off' + index" style="margin:0;cursor: pointer;" @click="setDialogData(item)">
        <v-col :cols="6" style="padding-top:0.3rem;padding-bottom:0.3rem;padding-right:0.3rem;">
          <div style="text-overflow:ellipsis;overflow:hidden;width:100%;position: relative;" :title="item.name">
            <span style="color:#9e9e9e;width:15px;display:inline-block;position: absolute;">{{ index + 1 }}</span>
            <span style="display:inline-block;margin-left:17px;">{{item.name}}</span>
          </div>
        </v-col>
        <v-col :cols="5" style="padding:0.3rem 0.2rem 0.3rem 0.2rem;text-align:center;">
          <v-icon v-if="!item.is_occupy" style="color:#FB8C00;">mdi-close</v-icon>
          <div v-else-if="item.online" style="color:#67C23A;">在线</div>
          <div v-else style="color:#FB8C00;">离线</div>
        </v-col>
        <v-col :cols="12" style="padding-top: 0px;padding-bottom: 0px;">
          <div style="color:#9e9e9e;margin-left:17px;">
            <span style="display:inline-block;margin-right:10px;">{{item.ip}}</span>
            <span style="display:inline-block;margin-right:10px;">通道：{{(item.index + 1)}}</span>
            <span v-if="item.online && (item.record_static != 1 || item.signal_static != 0 || item.hardware_static != 0)" style="border: 1px solid #9e9e9e;border-radius: 2px;padding: 0 10px;display: inline-block;">
              <span v-if="item.record_static != 1" style="display:inline-block;margin-right:10px;">
                录像
                <span style="color:#FB8C00;">暂停</span>
              </span>
              <span v-if="item.record_static != 1 && item.signal_static != 0" style="margin-right:10px;">/</span>
              <span v-if="item.signal_static != 0" style="display:inline-block;margin-right:10px;">
                信号
                <span style="color:#FB8C00;">异常</span>
              </span>
              <span v-if="(item.record_static != 1 || item.signal_static != 0) && item.hardware_static != 0" style="margin-right:10px;">/</span>
              <span v-if="item.hardware_static != 0" style="display:inline-block;">
                硬件
                <span style="color:#FB8C00;">异常</span>
              </span>
            </span>
            <!-- <span style="display:inline-block;margin-right:10px;">
              录像：
              <span v-if="item.record_static == 1" style="color:#67C23A;">正常</span>
              <span v-else style="color:#FB8C00;">异常</span>
            </span>
            <span style="margin-right:10px;">/</span>
            <span style="display:inline-block;margin-right:10px;">
              信号：
              <span v-if="item.signal_static == 0" style="color:#67C23A;">正常</span>
              <span v-else style="color:#FB8C00;">异常</span>
            </span>
            <span style="margin-right:10px;">/</span>
            <span style="display:inline-block;margin-right:10px;">
              硬件：
              <span v-if="item.hardware_static == 0" style="color:#67C23A;">正常</span>
              <span v-else style="color:#FB8C00;">异常</span>
            </span> -->
          </div>
        </v-col>
      </v-row>
      <v-divider v-if="abnormalList.length > 0" style="margin: 10px 0;"></v-divider>
      <v-row v-for="(item,index) in normalList" :key="index" style="margin:0;cursor: pointer;" @click="setDialogData(item)">
        <v-col :cols="6" style="padding-top:0.3rem;padding-bottom:0.3rem;padding-right:0.3rem;">
          <div style="text-overflow:ellipsis;overflow:hidden;width:100%;position: relative;" :title="item.name">
            <span style="color:#9e9e9e;width:15px;display:inline-block;position: absolute;">{{ index + 1 }}</span>
            <span style="display:inline-block;margin-left:17px;">{{item.name}}</span>
          </div>
        </v-col>
        <v-col :cols="5" style="padding:0.3rem 0.2rem 0.3rem 0.2rem;text-align:center;">
          <v-icon v-if="!item.is_occupy" style="color:#FB8C00;">mdi-close</v-icon>
          <div v-else-if="item.online" style="color:#67C23A;">在线</div>
          <div v-else style="color:#FB8C00;">离线</div>
        </v-col>
        <v-col :cols="12" style="padding-top: 0px;padding-bottom: 0px;">
          <div style="color:#9e9e9e;margin-left:17px;">
            <span style="display:inline-block;margin-right:10px;">{{item.ip}}</span>
            <span style="display:inline-block;margin-right:10px;">通道：{{(item.index + 1)}}</span>
            <span v-if="item.online && (item.record_static != 1 || item.signal_static != 0 || item.hardware_static != 0)" style="border: 1px solid #9e9e9e;border-radius: 2px;padding: 0 10px;display: inline-block;">
              <span v-if="item.record_static != 1" style="display:inline-block;margin-right:10px;">
                录像
                <span style="color:#FB8C00;">暂停</span>
              </span>
              <span v-if="item.record_static != 1 && item.signal_static != 0" style="margin-right:10px;">/</span>
              <span v-if="item.signal_static != 0" style="display:inline-block;margin-right:10px;">
                信号
                <span style="color:#FB8C00;">异常</span>
              </span>
              <span v-if="(item.record_static != 1 || item.signal_static != 0) && item.hardware_static != 0" style="margin-right:10px;">/</span>
              <span v-if="item.hardware_static != 0" style="display:inline-block;">
                硬件
                <span style="color:#FB8C00;">异常</span>
              </span>
            </span>
            <!-- <span style="display:inline-block;margin-right:10px;">
              录像
              <span v-if="item.record_static == 1">正常</span>
              <span v-else style="color:#FB8C00;">异常</span>
            </span>
            <span style="margin-right:10px;">/</span>
            <span style="display:inline-block;margin-right:10px;">
              信号
              <span v-if="item.signal_static == 0">正常</span>
              <span v-else style="color:#FB8C00;">异常</span>
            </span>
            <span style="margin-right:10px;">/</span>
            <span style="display:inline-block;margin-right:10px;">
              硬件
              <span v-if="item.hardware_static == 0">正常</span>
              <span v-else style="color:#FB8C00;">异常</span>
            </span> -->
          </div>
        </v-col>
      </v-row>
      <div v-if="abnormalList.length === 0 && normalList.length === 0" style="text-align:center;margin-top:1rem;color:#9e9e9e;font-size:0.8rem;">
          暂无通道设备
      </div>
      <v-dialog
        v-model="dialog"
        scrollable
        max-width="500px"
      >
        <v-card>
          <v-card-title>海康nvr通道详细信息</v-card-title>
          <v-divider></v-divider>
          <v-card-text style="height: 600px;">
            <v-row>
              <v-col :cols="12">
                <span style="color:#9e9e9e;width: 75px;display: inline-block;">通道名称</span>
                <span>{{nvrInfo.name}}</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col :cols="12">
                <span style="color:#9e9e9e;width: 75px;display: inline-block;">IP地址</span>
                <span>{{nvrInfo.ip}}</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col :cols="12">
                <span style="color:#9e9e9e;width: 75px;display: inline-block;">通道</span>
                <span>{{(nvrInfo.index + 1)}}</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col :cols="12">
                <span style="color:#9e9e9e;width: 75px;display: inline-block;">状态</span>
                <v-icon v-if="!nvrInfo.is_occupy" style="color:#FB8C00;">mdi-close</v-icon>
                <span v-else-if="nvrInfo.online" style="color:#67C23A;">在线</span>
                <span v-else style="color:#FB8C00;">离线</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col :cols="12">
                <span style="color:#9e9e9e;width: 75px;display: inline-block;">录像状态</span>
                <span v-if="nvrInfo.record_static == 1" style="color:#67C23A;">正常</span>
                <span v-else style="color:#FB8C00;">暂停</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col :cols="12">
                <span style="color:#9e9e9e;width: 75px;display: inline-block;">信号状态</span>
                <span v-if="nvrInfo.signal_static == 0" style="color:#67C23A;">正常</span>
                <span v-else style="color:#FB8C00;">异常</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col :cols="12">
                <span style="color:#9e9e9e;width: 75px;display: inline-block;">硬件状态</span>
                <span v-if="nvrInfo.hardware_static == 0" style="color:#67C23A;">正常</span>
                <span v-else style="color:#FB8C00;">异常</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col :cols="12">
                <span style="color:#9e9e9e;width: 75px;display: inline-block;">状态告警</span>
                <span v-if="nvrInfo.ae_occupy" style="color:#67C23A;">开启</span>
                <span v-else>关闭</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col :cols="12">
                <span style="color:#9e9e9e;width: 75px;display: inline-block;">录像告警</span>
                <span v-if="nvrInfo.ae_record" style="color:#67C23A;">开启</span>
                <span v-else>关闭</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col :cols="12">
                <span style="color:#9e9e9e;width: 75px;display: inline-block;">信号告警</span>
                <span v-if="nvrInfo.ae_signal" style="color:#67C23A;">开启</span>
                <span v-else>关闭</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col :cols="12">
                <span style="color:#9e9e9e;width: 75px;display: inline-block;">硬件告警</span>
                <span v-if="nvrInfo.ae_hardware" style="color:#67C23A;">开启</span>
                <span v-else>关闭</span>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <div style="width: 100%;text-align: right;">
              <v-btn
                elevation="2"
                @click="dialog = false"
              >
                关闭
              </v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import LoadingText from '../../../components/LoadingText'
export default {
  components: {
    LoadingText
  },
  props: {
    iotId: {
      type: String,
      default: ''
    },
    toLoad: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      loading: true,
      // 正常的
      normalList: [],
      // 有异常的
      abnormalList: [],
      dialog: false,
      nvrInfo: {}
    }
  },
  computed: {
  },
  mounted() {
    var that = this
    that.$nextTick(() => {
      that.initData()
    })
  },
  created() {
  },
  methods: {
    async initData() {
      var that = this
      if (!that.iotId || !that.toLoad) {
        that.loading = false
        return
      }
      var res = await that.$api.iot.getNvrChannelList({ iot_id: that.iotId })
      // console.log('getNvrChannelList.res', res)
      if (!res.success) {
        // that.$eleUtil.errorMsg('获取状态历史失败')
        console.log('获取NVR设备通道列表失败.', res)
        that.loading = false
        that.assign(0)
        return
      }
      var data = res.data
      that.assign(data.length)
      that.normalList = []
      that.abnormalList = []
      for (let index = 0; index < data.length; index++) {
        const item = data[index];
        if (item.record_static === 1 && item.signal_static === 0 && item.hardware_static === 0) {
          that.normalList.push(item)
          continue;
        }
        that.abnormalList.push(item)
      }
      that.loading = false
    },
    initDataV2() {
      var that = this
      for (let index = 0; index < 5; index++) {
        var item = {
          record_static: 1,
          signal_static: 0,
          hardware_static: 0,
          ip: '127.0.0.1',
          ChannelName: '测试' + index
        }
        that.normalList.push(item)
      }
      that.loading = false
    },
    // 赋值
    assign(v) {
      this.$emit('assign', v)
    },
    setDialogData(v) {
      var that = this
      that.nvrInfo = v
      that.dialog = true
    }


  }
}
</script>

<style scoped>
</style>
